import $ from 'jquery'

import makeReadOnly from './make-read-only'
window.makeReadOnly = makeReadOnly

document.addEventListener('DOMContentLoaded', () => {
  // warn about existing started documents when create new document
  $(document).on('click', '.btn-add', function(event) {
    const anyExistingDocuments = $(this).data("any-started-documents");
    const existingDocumentsMsg = $(this).data("started-documents-warning");
    if (anyExistingDocuments){
      if (confirm(existingDocumentsMsg)==false) {
        event.preventDefault();
      }
    }
  });

  // http://www.abeautifulsite.net/whipping-file-inputs-into-shape-with-bootstrap-3/

  // TODO used ?
  $(document).on('changeTODO', '.btn-file :file', function() {
    var input = $(this);
    numFiles = input.get(0).files ? input.get(0).files.length : 1;
    label = input.val().replace(/\\/g, '/').replace(/.*\//, '');
    input.trigger('fileselect', [numFiles, label]);
    var input1 = $(this).parents('.input-group').find(':text'),
    log = numFiles > 1 ? numFiles + ' files selected' : label;
    if(input1.length) {
      input1.val(log);
    } else {
      if(log) alert(log);
    }
  });
});
